import { koComponent } from "../../ko-utils";
import $api from "../../api";
import { InvitationModel, UserModel } from "../../models/Gen/BaseModels";
import AssignProjects from "./views/assignProjects";
import { isInPricingPlan } from "../../utils/flags";

class CompanyUsersView {
  constructor(params, parentPage) {
    this.isAssignProjectsVisible = ko.observable;

    this.users = ko.observableArray();

    // this.joins = ko.observableArray();

    this.invitations = ko.observableArray();
    this.newInvitation = ko.observable({
      currentCompany: ko.observable({
        hasAccessToAllProjects: ko.observable(true),
      }),
      projectSharings: ko.observableArray([]),
    });

    this.assignProjectsDialogShown = ko.observable(false);
    this.parentPage = parentPage;

    this.load();

    this.roles = [
      { name: "Manager", value: 0 },
      { name: "Editor", value: 1 },
    ];

    this.targetEmail = ko.observable();

    this.inviteEmail = ko.observable();
    this.inviteSelectedRole = ko.observable();
    this.isCurrentUserManager = ko.observable(false);

    this.projects = this.parentPage.getServerSideData("projects");

    this.isPermissionsSupportEnabled = ko.observable(
      isInPricingPlan("bf_prms", true)
    );
  }

  onAtiveTabChanged(tab) {}

  setActiveTab(tab) {
    if (this.onActiveTabChanging) {
      if (this.onActiveTabChanging(tab) === false) return;
    }

    this.activeTab(tab);

    if (this.tabsUseHashes) {
      window.location.hash = tab;
    }

    this.onAtiveTabChanged(tab);
  }

  enrichProjectSharings(u) {
    const newProjects = [];

    for (const projectSharing of u.projectSharings()) {
      const projects = this.projects.filter(
        (i) => i.id === projectSharing.projectId()
      );
      if (projects.length > 0) {
        projectSharing.name = ko.observable(projects[0].name);
        newProjects.push(projectSharing);
      }
    }

    u.projectSharings(newProjects);
  }

  enrichInvitationModel(inv) {
    inv.access().projects = ko.observableArray();
    inv.access().projectIds ??= ko.observableArray();

    for (const projectId of inv.access().projectIds()) {
      const projects = this.projects.filter((i) => i.id === projectId);
      if (projects.length > 0) {
        const project = projects[0];
        inv.access().projects.push({ id: project.id, name: project.name });
      }
    }
  }

  load() {
    this.users.removeAll();
    this.invitations.removeAll();

    $api.company.getUsers({}, {}, (resp) => {
      for (const user of resp) {
        const u = new UserModel(user);
        this.enrichProjectSharings(u);
        this.users.push(u);
      }

      const currentUsers = this.users().filter(
        (x) => x.email() === window.auth.user.Email
      );
      this.currentUser = currentUsers.length > 0 ? currentUsers[0] : null;
      this.isCurrentUserManager(this.currentUser.companyRole() === 0);
      this.newInvitation()
        .currentCompany()
        .hasAccessToAllProjects(
          this.currentUser.currentCompany().hasAccessToAllProjects()
        );
    });

    $api.company.getInvitations({}, {}, (resp) => {
      for (const inv of resp) {
        const i = new InvitationModel(inv);
        this.enrichInvitationModel(i);
        this.invitations.push(i);
      }
    });
  }

  invite() {
    const hasAccessToAllProjects = ko.unwrap(
      this.newInvitation().currentCompany().hasAccessToAllProjects
    );
    const projectSharings = ko
      .unwrap(this.newInvitation().projectSharings)
      .map((i) => i.projectId());

    $api.company.inviteUser(
      {},
      {
        email: ko.unwrap(this.inviteEmail).replace(/ /g, ""),
        role: ko.unwrap(this.inviteSelectedRole),
        assignedProjects: {
          hasAccessToAllProjects: hasAccessToAllProjects,
          projectIds: projectSharings,
        },
      },
      (resp) => {
        this.inviteEmail("");

        this.parentPage.showToast("Invitation was sent.");

        this.load();
      },
      (errResp) => {
        this.parentPage.showToast(
          "Invalid email or user is a member of some company",
          "error"
        );
      }
    );
  }

  removeUser(user) {
    if (confirm("Are you sure?")) {
      $api.company.removeUser({ id: ko.unwrap(user.id) }, {}, (resp) => {
        window.location.reload();
      });
    }
  }

  assignProjects(user) {
    this.parentPage.showDialog(AssignProjects(this), {
      currentUser: this.currentUser,
      user,
      newInvitation: null,
      projects: this.projects,
      isPermissionsSupportEnabled: this.isPermissionsSupportEnabled(),
    });
  }

  assignProjectsToNewInvitation() {
    this.parentPage.showDialog(AssignProjects(this), {
      currentUser: this.currentUser,
      user: null,
      newInvitation: this.newInvitation,
      projects: this.projects,
      isPermissionsSupportEnabled: this.isPermissionsSupportEnabled(),
    });
  }

  // showDialog(componentName, params, opts = {}) {
  //     // this.dialogComponentParams(params);
  //     // this.dialogComponentName(componentName);
  //     // this.dialogHasBackdrop(opts.backdrop !== false);
  //     // this.bodyFaded(opts.bodyFaded === true);
  //     this.dialogShown(true);
  // }

  removeInvitation(inv) {
    if (confirm("Are you sure?")) {
      $api.company.removeInvitation(
        { internalId: ko.unwrap(inv.internalId) },
        {},
        (resp) => {
          this.load();
        }
      );
    }
  }

  prolongInvitation(inv) {
    if (confirm("Are you sure?")) {
      console.log("aaaaa",ko.unwrap(inv))
      $api.company.prolongInvitation(
        { internalId: ko.unwrap(inv.internalId) },
        {},
        (resp) => {
          this.load();
          this.parentPage.showToast("Invitation was sent.");
        }
      );
    }
  }

  onRoleChanged(user, ev) {
    $api.users.changeRole(
      { id: ko.unwrap(user.id), role: ev.target.value },
      {},
      (resp) => {
        this.parentPage.showToast("Role changed.");
      }
    );
  }

  onInvitationRoleChanged(inv, ev) {
    $api.company.changeInvitationRole(
      { internalId: ko.unwrap(inv.internalId), role: ev.target.value },
      {},
      (resp) => {
        this.parentPage.showToast("Role changed.");
      }
    );
  }
}

export default koComponent("company-users-view", CompanyUsersView);
